import { ChangeDetectionStrategy, Component, inject, Input, OnInit, signal, WritableSignal } from '@angular/core';
import { NgClass } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { MODAL_TOKEN, ModalProvider } from '@core';
import { SingleRadioItemModel } from './single-radio-item.model';

@Component({
  selector: 'lib-selectable-single-radio-modal',
  templateUrl: './selectable-single-radio-modal.component.html',
  styleUrls: ['./selectable-single-radio-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [IonicModule, NgClass]
})
export class SelectableSingleRadioModalComponent<T> implements OnInit {
  // Note: Using @Input() because component is used via Ionic modal componentProps
  @Input() header!: string;
  @Input() buttonText!: string;
  @Input() providedData!: SingleRadioItemModel<T>[];
  @Input() selectedData!: T;

  private readonly modalProvider: ModalProvider = inject(MODAL_TOKEN);

  readonly providedDataSignal: WritableSignal<SingleRadioItemModel<T>[]> = signal<SingleRadioItemModel<T>[]>([]);
  readonly selectedDataSignal: WritableSignal<T | null> = signal<T | null>(null);

  ngOnInit(): void {
    this.providedDataSignal.set(this.providedData);
    this.selectedDataSignal.set(this.selectedData);
  }

  isSelected(value: T): boolean {
    return this.selectedDataSignal() === value;
  }

  hasSelection(): boolean {
    return this.selectedDataSignal() !== null && this.selectedDataSignal() !== undefined;
  }

  setData(event: CustomEvent): void {
    const distance: T = event.detail.value;
    this.selectedDataSignal.set(distance);
  }

  closeModal(): void {
    this.modalProvider.dismissModal$(this.selectedDataSignal());
  }
}
